import { useState } from 'react';
import {
	ChipField,
	CreateButton,
	Datagrid,
	ExportButton,
	FunctionField,
	ImageField,
	List,
	NumberField,
	ReferenceField,
	TextField,
	useNotify,
} from 'react-admin';
import { BiLink } from 'react-icons/bi';
import BoostsTemplateDialog from './BoostsTemplateDialog';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';

const ProactiveItemList = () => {
	const notify = useNotify();
	const [boostsTemplateDialogOpen, setBoostsTemplateDialogOpen] = useState(false);
	const location = useLocation();
	const isGlobalFromQuery = new URLSearchParams(location.search).get('is_global') === 'true';
	return (
		<>
			<BoostsTemplateDialog
				open={boostsTemplateDialogOpen}
				onClose={() => {
					setBoostsTemplateDialogOpen(false);
				}}
			/>
			<List
				filter={isGlobalFromQuery ? { is_global: true } : undefined}
				actions={
					<div>
						<Button onClick={() => setBoostsTemplateDialogOpen(true)}>OPEN</Button>
						<ExportButton />
						{!isGlobalFromQuery ? <CreateButton /> : null}
					</div>
				}
			>
				<Datagrid rowClick="edit" dir="rtl" bulkActionButtons={false}>
					<TextField source="title.he" label={'שם'} />
					<NumberField source="points" label="נקודות" />
					<TextField source="slug" />
					<TextField source="__t" label="סוג" />
					<TextField source="type" label="סוג תוכן" />
					<ImageField source="image" />
					<ReferenceField reference="proactive/item/category" source="category" label="קטגוריה">
						<ChipField source="name" />
					</ReferenceField>
					<NumberField source="viewsCount" label="צפיות" />
					<FunctionField
						render={(record: any) => (
							<button
								type="button"
								className="hover:scale-125 transition-transform h-8 w-8 place-items-center "
								onClick={(e) => {
									navigator.clipboard.writeText(`https://cdn.grouphug.online/${record.url}`);
									notify('הקישור הועתק ללוח', { type: 'info' });
									e.stopPropagation();
								}}
							>
								<BiLink />
							</button>
						)}
					/>
				</Datagrid>
			</List>
		</>
	);
};

export default ProactiveItemList;
